export const COUPON_STATUS = {
  NORMAL: 0,
  EXPIRED: 1,
}

export const COUPON_STATUS_STRING = [
  "정상",
  "만료됨"
]